import {
  List
} from 'immutable';

import { QUESTIONS_FETCH } from '../constants/ActionTypes';

const initialState = new List();
export default (state = initialState, action) => {
  switch (action.type) {
    case QUESTIONS_FETCH: {
      return action.payload;
    }
    default:
      return state;
  }
};
